<template>
    <el-dialog
        title="验证接受方注册情况"
        :visible="visible"
        custom-class="songs-rule-confirm"
        :show-close="false"
        :append-to-body="true"
        center
        width="620px"
    >
        <table style="width: 100%">
            <thead>
                <tr>
                    <th style="width: 20%">真实名字</th>
                    <th style="width: 25%">对方手机号</th>
                    <th style="width: 20%">验证情况</th>
                    <th>建议</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in tableList" :key="index">
                    <td>{{ item.toCpRealName }}</td>
                    <td>{{ item.toCpPhoneNum }}</td>
                    <td>
                        <span v-if="item.verifyStatus === 0" class="color-danger">未通过</span>
                        <span v-if="item.verifyStatus === 1" class="color-success">已通过</span>
                    </td>
                    <td>
                        <span v-if="item.verifyFailType === 1" class="color-info">
                            无法确认提交；你可以邀请对方免费注册和实名认证，再来确认提交；或者提交分成后，系统邀请该手机号进行注册，但你要保证填写的名称正确
                        </span>
                        <span v-if="item.verifyFailType === 2" class="color-info">
                            无法确认提交；对方已注册，但填写的名称手机号认证的名称不匹配，请和对方确认在秀动发行的实名认证名字
                        </span>
                        <span v-if="item.verifyFailType === 3" class="color-info">
                            无法确认提交；你可以让对方先在秀动发行上免费进行实名认证，再来确认提交
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="tableList[0] && tableList[0].verifyStatus != 1" @click="onSave(false)">返回修改</el-button>
            <el-button type="primary" v-if="tableList.length > 0 && tableList[0].verifyStatus === 1" @click="onSave(true)">确认提交</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            tableList: [],
            visible: false,
        };
    },
    methods: {
        async show(info) {
            this.visible = true;
            this.tableList = [info];
        },
        hide() {
            this.visible = false;
        },
        onSave(type) {
            this.hide();
            this.$emit('next', type ? (this.tableList[0].verifyStatus == 1 ? true : false) : false);
        },
    },
};
</script>
<style lang="scss">
.songs-rule-confirm {
    table {
        width: 100%;
        th,
        td {
            padding: 15px 10px;
            text-align: center;
            border: none;
        }
        th {
            background-color: $--background-secondary;
        }
    }
}
</style>
